import React, { useMemo, useState } from 'react';
import { Chip, ThemeProvider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { validationMessages } from '../../../../utils/constants';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from '../scss/addEditFormModal.module.scss';
import { PopUpIcon } from '../../Icons';
import { addToFunctions, theme } from '../helpers/helpers';
import colors from '../../../../scss/colors';

function FunctionsForm(props) {
  const { addEditForm } = props;

  const functionsDirections = useSelector((state) => state.constFromApi.functionsDirections);
  const [valuesToAdd, setValuesToAdd] = useState([]);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  let formFunctions = [];
  const initialItems = addEditForm.values?.functions?.map((jobFunction) => ({
    value: jobFunction.JobFunction.Name,
    JobFunctionId: jobFunction.JobFunction.Id
  }));

  formFunctions = addToFunctions(initialItems, formFunctions);

  const addHandler = (data) => {
    let changedFormFunctions = [];
    changedFormFunctions = addToFunctions(data, changedFormFunctions);
    setValuesToAdd([]);
    const allAddedFunctions = addEditForm.values?.functions.concat(changedFormFunctions);
    addEditForm.setFieldValue('functions', allAddedFunctions);
  };

  return (
    <>
      <span className={`${classes.constantText} mt-2`}>{t('common.forms.labels.function')}</span>
      {!addEditForm.values.functions?.length && <ValidationErrorLabel message={validationMessage.FUNCTION_REQ} />}
            <div className="flex flex-row">
        <div className="flex flex-col w-full">
          <Autocomplete
            value={valuesToAdd}
            open={open}
            multiple
            disableCloseOnSelect
            disablePortal
            options={functionsDirections.slice(1, functionsDirections.length)}
            getOptionLabel={(option) => option.label.toString()}
            popupIcon={<PopUpIcon />}
            renderOption={(params, option) => {
              return (
                !addEditForm.values.functions.some((opt) => opt.JobFunction.Id === option.JobFunctionId) && (
                  <li {...params} className="cursor-pointer hover:bg-gray-200 d-flex justify-content-between align-items-center ms-3 me-1  py-2">
                    {option.label}
                  </li>
                )
              );
            }}
            onChange={(event, value) => {
              setValuesToAdd(value);
              addHandler(value);
            }}
            renderInput={(params) => (
              <div className={classes.autocompleteInput}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <TextField
                  {...params}
                  label={t('profile.builder.addjobfunction')}
                  variant="outlined"
                  onFocus={() => setOpen(true)}
                  onBlur={() => setOpen(false)}
                  onClick={() => setOpen(true)}
                  onInput={() => setOpen(true)}
                  fullWidth
                  sx={{
                    marginBottom: '20px'
                  }}
                />
              </div>
            )}
            variant="standard"
          />
        </div>
      </div>
      <div className={`${classes.skillsList} mb-2 flex flex-col w-full border-b-1 border-gray-300 pb-6`}>
        {addEditForm.values?.functions?.map((item) => (
          <ThemeProvider key={item.JobFunction.Id} theme={theme}>
            <Chip
              className={classes.chip}
              label={item.JobFunction.Name}
              deleteIcon={<CloseIcon fontSize="small" color="warning" />}
              color="primary"
              variant="filled"
              onDelete={() =>
                addEditForm.setFieldValue(
                  'functions',
                  addEditForm.values?.functions.filter(
                    (jobFunction) => jobFunction.JobFunction.Id !== item.JobFunction.Id
                  ),
                  true
                )
              }
              sx={{ color: colors.WHITE, fontSize: '14px' }}
            />
          </ThemeProvider>
        ))}
      </div>
    </>
  );
}

export default FunctionsForm;
